export const stripHtml = (str) => str?.replace(/<[^>]*>/g, '').trim()
